import React from 'react'
import { Link } from 'react-router-dom'
import socialLinks from '../../config/socialLinks'

export default function Menu() {
    return (
        <>
            {/* Navbar Start */}
            <div className="container-fluid mt-4 py-3 shadow-sm">
                <div className="container">
                    <nav className="navbar navbar-expand-lg bg-white navbar-light py-lg-0 px-lg-3 site-navbar sticky-top">
                        <Link to="/" className="navbar-brand d-lg-none d-flex align-items-center me-auto">
                            <span className="fw-bold">100Eyes</span>
                        </Link>
                        <button type="button" className="navbar-toggler me-0" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                            <span className="navbar-toggler-icon" />
                        </button>
                        <div className="collapse navbar-collapse" id="navbarCollapse">
                            <div className="navbar-nav">
                                <Link to="/" className="nav-item nav-link">Home</Link>
                                <Link to="about-us" className="nav-item nav-link">About Us</Link>
                                <Link to="service" className="nav-item nav-link">Our Services</Link>
                                <Link to="blogs" className="nav-item nav-link">Blogs</Link>
                                <Link to="features" className="nav-item nav-link">Features</Link>
                                <Link to="contact-us" className="nav-item nav-link">Contact Us</Link>
                                <Link to="call-us" className="nav-item nav-link">Call Us</Link>
                            </div>
                            <div className="ms-auto d-none d-lg-flex">
                                <a className="btn btn-sm-square btn-primary ms-2" href={socialLinks.facebook} target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f" /></a>
                                <a className="btn btn-sm-square btn-primary ms-2" href={socialLinks.twitter} target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter" /></a>
                                <a className="btn btn-sm-square btn-primary ms-2" href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in" /></a>
                                <a className="btn btn-sm-square btn-primary ms-2" href={socialLinks.instagram} target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram" /></a>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
            {/* Navbar End */}

        </>
    )
}
